/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require("./bootstrap");

// Require events file
require("./events.js");

// Require directives file
require("./directives/toggleNav.js");

/**
 * 3rd party Vue components
 */
import MaskedInput from "vue-text-mask";
import vSelect from "./vue-select/src/index";

Vue.component("masked-input", MaskedInput);
Vue.component("v-select", vSelect);
Vue.component("button-ladda", require("./components/ButtonLadda.vue").default);
Vue.component("form-field", require("./components/FormField.vue").default);
Vue.component("print-button", require("./components/PrintButton.vue").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component("dashboard-table", () => import("./tables/DashboardTable.vue"));
Vue.component("dealer-groups-table", () => import("./tables/DealerGroupsTable.vue"));
Vue.component("dealerships-table", () => import("./tables/DealershipsTable.vue"));
Vue.component("users-table", () => import("./tables/UsersTable.vue"));
Vue.component("makes-table", () => import("./tables/MakesTable.vue"));
Vue.component("guarantees-table", () => import("./tables/GuaranteesTable.vue"));
Vue.component("batches-table", () => import("./tables/BatchesTable.vue"));

Vue.component("filter-bar", () => import("./tables/components/FilterBar.vue"));

Vue.component("dealer-group-form", () => import("./forms/DealerGroupForm.vue"));
Vue.component("dealership-form", () => import("./forms/DealershipForm.vue"));
Vue.component("user-form", () => import("./forms/UserForm.vue"));
Vue.component("batch-form", () => import("./forms/BatchForm.vue"));
Vue.component("make-form", () => import("./forms/MakeForm.vue"));
Vue.component("form-guarantee-details", () => import("./forms/FormGuaranteeDetails.vue"));
Vue.component("form-guarantee-car-details", () => import("./forms/FormGuaranteeCarDetails.vue"));
Vue.component("form-guarantee-customer-details", () => import("./forms/FormGuaranteeCustomerDetails.vue"));
Vue.component("form-guarantee-confirmation", () => import("./forms/FormGuaranteeConfirmation.vue"));
Vue.component("form-guarantee-edit", () => import("./forms/FormGuaranteeEdit.vue"));
Vue.component("form-register-guarantee-edit", () => import("./forms/register/FormGuaranteeEdit.vue"));
Vue.component("form-guarantee-access", () => import("./forms/FormGuaranteeAccess.vue"));

Vue.component("app-date-picker", () => import("./components/AppDatePicker.vue"));
Vue.component("faq-item", () => import("./components/FaqItem.vue"));

Vue.component("navigation", () => import("./components/Navigation.vue"));

const app = new Vue({
    el: "#app",
    methods: {
        honeypot(event) {
            if (!document.getElementById("honeypot").value) return true;

            event.preventDefault();
            return false;
        }
    }
});
